import Device from 'constants/deviceSizes';

import { containerStyle } from '../../../SignUp/styles';

export default {
  container: {
    ...containerStyle
  },
  link: {
    display: 'flex',
    marginTop: 4,
    textDecoration: 'none'
  },
  field: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: 85
  },
  socialNetworks: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 'auto',
    padding: '60px 0px 10px',
    alignSelf: 'flex-end',
    [Device.mobile]: {
      padding: 0,
      minHeight: 50
    }
  },
  socialIcon: {
    height: 25,
    width: 25,
    margin: '0 5px'
  },
  loading: {
    marginTop: 30
  }
};
